import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private history: string[] = [];
  private mapSearch = new Map<string, any>();

  constructor(private router: Router, private location: Location) {}

  public startSaveHistory(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public goBack(): void {
    //remove last url and get reference
    let url = this.history.pop();
    if (url) {
      //if reference exists, remove object in map
      this.mapSearch.delete(url);
    }
    //if there are any urls in history array, go back else return in root url
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  public getPreviousUrl(): string {
    if (this.history.length > 0) {
      return this.history[this.history.length - 1];
    }

    return '';
  }

  /**Save object in map with key url and value any */
  public saveHistorySearch(object: any = {}): void {
    let currentUrl = this.router.url;
    this.mapSearch.set(currentUrl, object);
  }

  /** Get Object saved into map, if empty return undefined */
  public getCurrentHistorySearch(): any {
    let prevUrl = this.getPreviousUrl();
    return this.mapSearch.get(prevUrl);
  }

  public clearHistorySearch() {
    this.history = [];
    this.mapSearch.clear();
  }
}
